// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mine-timeout-modal {
  backdrop-filter: blur(3px) saturate(0.7);
  background-color: var(--black-80);
}
.mine-timeout-modal .modal-dialog {
  max-width: 400px;
  margin: 2rem auto;
}
.mine-timeout-modal .modal-dialog .modal-content {
  background: #09090B;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 0.5rem;
}
.mine-timeout-modal .modal-dialog .modal-content .modal-body {
  padding: 2rem 1.5rem;
  position: relative;
  border-radius: 1rem;
  background: #000;
  text-align: center;
}
.mine-timeout-modal .modal-dialog .modal-content .modal-body .mine-settings-heading {
  color: var(--Solid--Orange-100, #FF9F45);
  font-weight: 800;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
}
.mine-timeout-modal .modal-dialog .modal-content .modal-body p {
  color: var(--white);
  font-size: 1rem;
  margin-bottom: 2rem;
}
.mine-timeout-modal .modal-dialog .modal-content .modal-body .btn-ok-mine {
  border-color: transparent;
  background: #2B2B2B;
  border-radius: 50px;
  font-size: 1rem;
  text-transform: uppercase;
  color: var(--white);
  font-weight: 700;
  min-height: 48px;
  box-shadow: none;
  transition: background 0.2s;
}
.mine-timeout-modal .modal-dialog .modal-content .modal-body .btn-ok-mine:is(:hover, :active):enabled {
  background: #232323;
}
@media screen and (max-width: 575.98px) {
  .mine-timeout-modal .modal-dialog {
    max-width: 95vw;
    margin: 1rem auto;
  }
  .mine-timeout-modal .modal-dialog .modal-content .modal-body {
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/games/Plinko/GameTheme/PyramidPlinkoGame/components/TimeoutModal/TimeoutModal.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;EACA,iCAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;AACJ;AACI;EACE,mBAAA;EACA,wCAAA;EACA,qBAAA;AACN;AACM;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACR;AACQ;EACE,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AACV;AAEQ;EACE,mBAAA;EACA,eAAA;EACA,mBAAA;AAAV;AAGQ;EACE,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;AADV;AAGU;EACE,mBAAA;AADZ;AAQE;EACE;IACE,eAAA;IACA,iBAAA;EANJ;EASM;IACE,aAAA;EAPR;AACF","sourcesContent":[".mine-timeout-modal {\n  backdrop-filter: blur(3px) saturate(0.7);\n  background-color: var(--black-80);\n\n  .modal-dialog {\n    max-width: 400px;\n    margin: 2rem auto;\n\n    .modal-content {\n      background: #09090B;\n      border: 1px solid rgba(255, 255, 255, 0.00);\n      border-radius: 0.5rem;\n\n      .modal-body {\n        padding: 2rem 1.5rem;\n        position: relative;\n        border-radius: 1rem;\n        background: #000;\n        text-align: center;\n\n        .mine-settings-heading {\n          color: var(--Solid--Orange-100, #FF9F45);\n          font-weight: 800;\n          font-size: 1.5rem;\n          margin-bottom: 1.5rem;\n        }\n\n        p {\n          color: var(--white);\n          font-size: 1rem;\n          margin-bottom: 2rem;\n        }\n\n        .btn-ok-mine {\n          border-color: transparent;\n          background: #2B2B2B;\n          border-radius: 50px;\n          font-size: 1rem;\n          text-transform: uppercase;\n          color: var(--white);\n          font-weight: 700;\n          min-height: 48px;\n          box-shadow: none;\n          transition: background 0.2s;\n\n          &:is(:hover, :active):enabled {\n            background: #232323;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 575.98px) {\n    .modal-dialog {\n      max-width: 95vw;\n      margin: 1rem auto;\n\n      .modal-content {\n        .modal-body {\n          padding: 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
